@import '../../../../assets/common';

#healthDashboardOverview {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  height: calc(var(--spacer) * 10);
  width: 100%;
  cursor: default;
  position: relative;

  .overview-section {
    display: flex;
    flex: 1;
    flex-flow: column;
    align-items: center;
    gap: var(--spacer);

    .section {
      &-title {
        display: flex;
        align-items: center;
        gap: var(--spacer);
        color: var(--main-titles-inputs-600);
      }
      &-value {
        color: var(--main-titles-inputs-600);
      }
    }
  }
}

.loading-container {
  display: flex;
  justify-content: space-between;
  height: calc(var(--spacer) * 10);
  padding: 0 calc(var(--spacer) * 3);
  gap: calc(var(--spacer) * 4);

  .loader {
    &-item {
      display: flex;
      flex: 1;
      flex-flow: column;
      align-items: center;
      gap: calc(var(--spacer) * 3);
      cursor: default;
    }
    &-name {
      color: var(--main-titles-inputs-600);
    }
  }

  gz-loader {
    height: fit-content;
  }
}

.separator {
  background-color: var(--chart-101-pressed-dividers);
  width: 1px;
  height: 80%;
  margin: auto;
}

.changed-info-box {
  position: absolute;
  background-color: var(--white-layout-302-level-1-elevation);
  width: calc(25% - 1px);
  top: calc(var(--spacer) * -1.5);
  height: calc(100% + var(--spacer) * 3);
  overflow: auto;

  gz-info-box {
    padding: 0;
    --info-box-width: 100%;
    --info-box-message-width: calc(100% - var(--spacer) * 7);
  }
}
